/* istanbul ignore file */
export const convertFloat32ToInt16 = (float32Array: Float32Array): Int16Array => {
  const int16Array = new Int16Array(float32Array.length);
  for (let i = 0; i < float32Array.length; i += 1) {
    int16Array[i] = float32Array[i] * 32767;
  }
  return int16Array;
};
